import React from 'react';
import { takeEvery, put, all } from 'redux-saga/effects';

import * as types from '../../actions/school-dashboard/types';
import * as actions from '../../actions/school-dashboard';

import vacancyStatuses from '../../constants/vacancy-statuses';

import apiFetcher from '../../tools/api-fetcher';
import queryStringify from '../../tools/query-stringify';
import handleError from '../../tools/error-helper';

import 'react-redux-toastr/';

function* getSchoolDashboardData({ schoolId, maxRecentlyViewedApplicationsCount }) {
  yield put(actions.setSchoolDashboardLoading(true));

  try {
    const statuses = Object.values(vacancyStatuses);
    const schoolIds = [schoolId];

    const [
      newApplicationsPerVacancy,
      recentlyViewedApplication,
      vacanciesToConfirmStatus,
      numberOfVacancies,
      applicationsPerWeek,
      applicationsPerVacancyPerWeek,
      postedVacanciesPerWeek,
      closedVacanciesPerWeek
    ] = yield all([
      apiFetcher
        .auth()
        .get(`schools/${schoolId}/statistics/new-applications-per-vacancy`),
      apiFetcher
        .auth()
        .get(`schools/${schoolId}/statistics/recently-viewed-applications?${queryStringify({ maxApplicationsCount: maxRecentlyViewedApplicationsCount })}`),
      apiFetcher
        .auth()
        .get(`schools/${schoolId}/statistics/vacancies-to-confirm-status`),
      apiFetcher
        .auth()
        .get(`schools/vacancies/status-stats?${queryStringify({ statuses, schoolIds })}`),
      apiFetcher
        .auth()
        .get(`schools/${schoolId}/statistics/applications-per-week`),
      apiFetcher
        .auth()
        .get(`schools/${schoolId}/statistics/applications-per-vacancy-per-week`),
      apiFetcher
        .auth()
        .get(`schools/${schoolId}/statistics/posted-vacancies-per-week`),
      apiFetcher
        .auth()
        .get(`schools/${schoolId}/statistics/closed-vacancies-per-week`)
    ]);

    const data = {
      newApplicationsPerVacancy: newApplicationsPerVacancy.data,
      recentlyViewedApplication: recentlyViewedApplication.data,
      vacanciesToConfirmStatus: vacanciesToConfirmStatus.data,
      numberOfVacancies: numberOfVacancies.data,
      applicationsPerWeek: applicationsPerWeek.data,
      applicationsPerVacancyPerWeek: applicationsPerVacancyPerWeek.data,
      postedVacanciesPerWeek: postedVacanciesPerWeek.data,
      closedVacanciesPerWeek: closedVacanciesPerWeek.data
    };

    yield put(actions.setSchoolDashboardData(data));
  } catch (exception) {
    handleError(exception, 'Failed to load data for the School Dashboard.');
  }

  yield put(actions.setSchoolDashboardLoading(false));
}

export default function* schoolDashboardSaga() {
  yield all([
    takeEvery(types.SCHOOL_DASHBOARD_GET_DATA, getSchoolDashboardData),
  ]);
}


// WEBPACK FOOTER //
// ./src/sagas/school/school-dashboard.js